export default "__VITE_ASSET__DF9AvQBz__"